const DiagramTreeAlignment = Object.freeze({
  CenterSubtrees: 20,
  CenterChildren: 21,
  Start: 22,
  End: 23,
  Bus: 24,
  BusBranching: 25,
  TopLeftBus: 26,
  BottomRightBus: 27,
});

export default DiagramTreeAlignment;
